import { ProjectFragment, PurchasedEnergyType } from '../generated/graphql'

/**
 * Yearly energy emission coefficients with the unit kg CO₂e / MWh
 */
export const energyTypeToEmissionCoefficientMap: Record<
  PurchasedEnergyType,
  Record<number, number>
> = {
  [PurchasedEnergyType.Heating]: {
    2020: 171,
    2025: 90,
    2030: 59,
    2040: 36,
    2050: 33,
    2060: 12,
    2070: 6,
    2080: 4,
    2090: 2,
    2100: 1,
    2110: 1,
    2120: 0,
    2130: 0,
    2140: 0,
    2150: 0,
  },
  [PurchasedEnergyType.Cooling]: {
    2020: 42,
    2025: 20,
    2030: 14,
    2040: 11,
    2050: 10,
    2060: 3,
    2070: 2,
    2080: 1,
    2090: 1,
    2100: 0,
    2110: 0,
    2120: 0,
  },
  [PurchasedEnergyType.Electricity]: {
    2020: 146,
    2025: 68,
    2030: 50,
    2040: 39,
    2050: 39,
    2060: 12,
    2070: 7,
    2080: 4,
    2090: 2,
    2100: 1,
    2110: 1,
    2120: 0,
    2130: 0,
    2140: 0,
    2150: 0,
  },
  [PurchasedEnergyType.Fuel]: {
    2020: 306,
    2500: 306,
  },
}

const INSPECTION_LENGTH_IN_YEARS = 50

export type EmissionModel = {
  buildingYear: number
  inspectionLengthInYears: number
}

export function getEmissionModel(project: ProjectFragment): EmissionModel {
  return {
    buildingYear: project.calendarYear ?? new Date().getFullYear(),
    inspectionLengthInYears: INSPECTION_LENGTH_IN_YEARS,
  }
}

export const COEFFICIENT_CHECKPOINT_YEARS = [2050, 2100]
